/* eslint-disable react/jsx-curly-brace-presence */
/* eslint-disable jsx-a11y/accessible-emoji */
import clsx from "clsx";
import getBaseUrl from "lib/utils/getBaseUrl";
import * as React from "react";

interface IWorkshopCaixaPretaFundamenteiProps extends React.HTMLAttributes<HTMLDivElement> {
  popUpTitle: React.ReactNode;
  externalLinkText: string;
  externalLinkHref: string;
  children: React.ReactNode;
  onClose: () => void;
}

export default function WorkshopCaixaPretaFundamentei({
  popUpTitle,
  externalLinkText,
  externalLinkHref,
  children,
  onClose,
  className,
  ...props
}: IWorkshopCaixaPretaFundamenteiProps) {
  return (
    <div className="px-6 xl:p-0">
      <div
        className={clsx(
          "relative rounded-md py-6 px-6 font-aeonik",
          `bg-gradient-to-r from-[#3f5fe9] to-red-500/90`,
          `sm:rounded-xl sm:shadow-lg`,
          className,
        )}
        {...props}
      >
        <div className="relative space-y-4">
          {popUpTitle}

          <div className="flex flex-col items-center space-y-4 sm:flex-row sm:space-y-0 sm:space-x-2">
            <div className="text-sm font-normal leading-6 tracking-wide text-white md:text-base">{children}</div>

            <a
              href={externalLinkHref}
              target="_blank"
              rel="noopener noreferrer"
              className={clsx(
                "flex w-full items-center justify-center whitespace-nowrap rounded-md bg-white py-3 px-12 text-xs",
                "font-semibold uppercase tracking-wider text-orange-700 shadow-sm md:w-auto md:text-xs",
                "hover:border-solid hover:bg-orange-100 hover:text-orange-700 hover:drop-shadow-sm",
              )}
            >
              {externalLinkText}
            </a>
          </div>

          <div className="flex items-center space-x-2">
            <img
              src={`${getBaseUrl()}/static/people/eduardo.jpg`}
              alt="Eduardo Cavalcanti"
              className="h-8 w-8 rounded-3xl md:h-12 md:w-12"
              width={48}
              height={48}
            />

            <div className="text-white">
              <h3 className="text-sm font-semibold drop-shadow-2xl md:text-sm">Eduardo Cavalcanti</h3>
              <p className="text-[10px] font-normal italic tracking-wide text-gray-200 md:text-xs">
                Cofundador do Fundamentei
              </p>
            </div>
          </div>
        </div>

        <div className="absolute top-0 right-0 -m-3">
          <button
            type="button"
            aria-label="Fechar"
            onClick={() => onClose()}
            className="cursor-pointer rounded-full bg-red-500 p-1 text-white shadow-lg hover:bg-red-400"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-4 w-4"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={3}
            >
              <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
}
